<template>
    <div v-loading="pageLoading">
        <el-form
            :model="formData"
            :rules="rules"
            ref="formData"
            label-position="top"
        >
            <el-row :gutter="40">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="title" label="主题名称:">
                        <el-input
                            placeholder="请输入主题名称"
                            v-model="formData.title"
                            :maxlength="60"
                            size="medium"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="serialNum" label="序号:">
                        <el-input
                            placeholder="请输入序号"
                            v-model="formData.serialNum"
                            type="number"
                            size="medium"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="40">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="coverImg" label="封面图:">
                        <img-upload :url.sync="formData.coverImg" :urlFull.sync="formData.coverImg">
                            <el-link slot="size" type="primary" :href="`${sswap}/pages/helpCenter/help/help?terminal=2&menuId=29`" target="_blank">查看尺寸规范</el-link>
                        </img-upload>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="detailImg1" label="详情图1:">
                        <img-upload :url.sync="formData.detailImg1" :urlFull.sync="formData.detailImg1">
                            <el-link slot="size" type="primary" :href="`${sswap}/pages/helpCenter/help/help?terminal=2&menuId=29`" target="_blank">查看尺寸规范</el-link>
                        </img-upload>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="40">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="detailImg2" label="详情图2:">
                        <img-upload :url.sync="formData.detailImg2" :urlFull.sync="formData.detailImg2">
                            <el-link slot="size" type="primary" :href="`${sswap}/pages/helpCenter/help/help?terminal=2&menuId=29`" target="_blank">查看尺寸规范</el-link>
                        </img-upload>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="waitingImg" label="候场图:">
                        <img-upload :url.sync="formData.waitingImg" :urlFull.sync="formData.waitingImg">
                            <el-link slot="size" type="primary" :href="`${sswap}/pages/helpCenter/help/help?terminal=2&menuId=29`" target="_blank">查看尺寸规范</el-link>
                        </img-upload>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="40">
                <el-col :xs="24" :sm="24" :xl="16">
                    <el-form-item prop="eventIds" label="直播事件:">
                        <el-input v-model="eventId" class="input-with-select" placeholder="请输入直播事件ID" size="medium">
                            <el-button slot="append" icon="el-icon-circle-plus" @click="searchEvent">添加</el-button>
                        </el-input>
                        <small class="from-tip"><span class="el-icon-warning"></span> 通过ID查询并添加,绑定相关直播事件</small>
                        <el-table
                            v-if="eventList && eventList.length > 0"
                            :data="eventList"
                            border
                            style="width: 100%"
                            size="small"
                        >
                            <el-table-column prop="id" label="ID"></el-table-column>
                            <el-table-column prop="title" label="名称"></el-table-column>
                            <el-table-column fixed="right" label="操作" width="80">
                                <template slot-scope="scope">
                                    <el-button
                                        type="text"
                                        size="small"
                                        icon="el-icon-delete"
                                        @click="del(scope.row.id)"
                                        >删除</el-button
                                    >
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                </el-col>
            </el-row>
            
            <el-row :gutter="40">
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="detail" label="详情:">
                        <tinymce v-model="formData.detail" :toolbar="toolbar" :menubar="false" v-if="reFresh"></tinymce>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-form-item>
                <el-button @click="goBack">返回取消</el-button>
                <el-button
                    type="primary"
                    @click="onSubmit"
                    :loading="btnLoading"
                    >确认提交</el-button
                >
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Tinymce from '@/components/Tinymce'; 
import ImgUpload from '@/components/ImageUpload';
export default {
    props: {
        id: {
            type: [Number, String],
            default: null,
        },
    },
    components:{Tinymce,ImgUpload},
    data() {
        return {
            formData: {
                title: "",
                serialNum:0,
                detail:"",
                eventIds:[],
                coverImg:'',
                detailImg1:'',
                detailImg2:'',
                waitingImg:''
            },
            rules: {
                title: [{ required: true, message: "请输入主题名称" }],
                eventIds: [{ required: true, message: "请选择直播事件" }],
                coverImg: [{ required: true, message: "请上传封面图" }],
                detailImg1: [{ required: true, message: "请上传详情图1" }],
                detailImg2: [{ required: true, message: "请上传详情图2" }],
                waitingImg: [{ required: true, message: "请上传侯场图" }],
                detail:[{ required: true, message: "请输入详情"}]
            },
            btnLoading: false,
            pageLoading: false,
            redirect: this.$route.query.redirect || "/live/theme/list",
            reFresh:false,
            v: this.$route.query.v || '',
            toolbar:['formatselect fontsizeselect | forecolor bold strikethrough | alignleft aligncenter alignright alignjustify | image media | preview fullscreen'],
            eventId:'',
            eventList:[],
            sswap:`${process.env.VUE_APP_SSWAP_URL}`
        };
    },
    created() {
        if (this.id) {
            this.getData();
        }else{
            this.reFresh = true;
        }
    },
    methods: {
        
        // 获取详情
        getData() {
            this.pageLoading = true;
            this.$request({
                url: "/live/theme/detail",
                method: "POST",
                params: { id: this.id },
            }).then((res) => {
                //处理成功回调
                const { state, msg, result } = res.data;
                if (state && state == 1 && result) {
                    this.formData = {
                        ...result,
                        eventIds:[]
                    }
                    this.eventList = result.events || []
                    this.eventList.forEach( item => {
                        this.formData.eventIds.push(item.id);
                    })
                    this.reFresh = true;
                } else {
                    return this.$message.error(msg || "获取详情失败");
                }
            }).finally(() => {
                this.pageLoading = false;
            });
        },
        //表单提交
        onSubmit() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: !this.id ? "/live/theme/create" : "/live/theme/update",
                        method: "POST",
                        data: this.formData,
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                this.goBack();
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
        //返回
        goBack() {
            this.$router.push({
                path: this.redirect,
            });
        },
         //搜索直播事件
        searchEvent() {
            if (this.eventId !== "") {
                this.dataLoading = true;
                this.$request({
                    url: "/live/event/noRepeatBind",
                    params: { eventId: this.eventId,themeId: this.id || '' },
                    method: "post",
                })
                    .then((res) => {
                        const { state, result, msg } = res.data;
                        if (state == 1 && result) {
                            // result.map(item => {
                                const _obj = this.eventList.find(v => v.id === result.id)
                                if( !_obj ){
                                    this.eventList.push(result) ;
                                    this.formData.eventIds = this.formData.eventIds.concat(result.id);
                                    this.$refs["formData"].clearValidate('eventIds');
                                    this.eventId = ''
                                }
                            // })

                        }else{
                            this.$message.error(msg || '没有找到相关直播事件');
                        }
                    }).catch(() => {
                        this.$message.error('系统错误');
                    }).finally(() => {
                        this.dataLoading = false;
                    });
            }
        },
        //删除演出
        del(id){
            const _msg = '确定要删除吗?';
            this.$confirm(_msg, '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.eventList = this.eventList.filter( item => item.id !== id);
                this.formData.eventIds = this.formData.eventIds.filter( item => item !== id);
            })
        },
    },
};
</script>

<style lang="scss" scoped>

</style>